module.exports = __webpack_public_path__ + "static/media/flushed.16187434.svg";